import fetch from 'app/utils/requests/fetch';
import { getPersistedState } from 'state/auth';

type CreateHyrox365ServiceArgs = {
  apiUrl: string;
};

type GymUpdateLinkResponse = {
  redirectUrl?: string;
  url?: string;
};

const getApiRoot = (apiUrl: string) => apiUrl.replace(/\/graphql\/?$/, '').replace(/\/$/, '');

const isValidRedirectUrl = (url: string): boolean => {
  try {
    return ['http:', 'https:'].includes(new URL(url).protocol);
  } catch {
    return false;
  }
};

const createHyrox365Service = ({ apiUrl }: CreateHyrox365ServiceArgs) => {
  const createGymUpdateLink = async (): Promise<string> => {
    const { authorization } = getPersistedState();
    const { body } = await fetch(`${getApiRoot(apiUrl)}/hyrox365/v1/gyms/me/update-link`, {
      headers: {
        ...(authorization ? { Authorization: authorization } : {}),
        'content-type': 'application/json',
      },
      method: 'POST',
    });

    const { redirectUrl, url } = body as GymUpdateLinkResponse;
    const resolvedUrl = redirectUrl || url;

    if (!resolvedUrl || !isValidRedirectUrl(resolvedUrl)) {
      throw new Error('Hyrox365 update link response did not include a redirect URL');
    }

    return resolvedUrl;
  };

  return {
    createGymUpdateLink,
  };
};

export type Hyrox365Service = ReturnType<typeof createHyrox365Service>;

export default createHyrox365Service;
